import React from 'react';
import { ArrowRightOutlined } from '@ant-design/icons';
import useReveal from '../../AIEmployees/useReveal';
import { trackEvent } from '../../../utils/analytics';
import '../../AIEmployees/sections/AIEClose.css';

/**
 * A2AClose — the final CTA beat for /agent-to-agent.
 *
 * Replaces the shared AIEClose, whose copy ("Hire your first AI employee")
 * contradicted this page's CTA (get an API key) — a visitor reading the close
 * was being sold a different product than the button offered.
 */
const A2AClose = ({ ctaLabel, onPrimary }) => {
  const [ref, visible] = useReveal();
  const seenRef = React.useRef(false);
  React.useEffect(() => {
    if (visible && !seenRef.current) {
      seenRef.current = true;
      trackEvent('section_view', { section: 'close', page: 'agent-to-agent' });
    }
  }, [visible]);

  return (
    <section className="aie-close" ref={ref}>
      <div className="aie-close__glow" aria-hidden="true" />
      <div className={`aie-close__inner aie-reveal ${visible ? 'is-visible' : ''}`}>
        <h2 className="aie-close__title aie-display">
          Give your agent the whole platform.
        </h2>
        <p className="aie-close__sub">
          One API key unlocks every CellCog capability: research, documents,
          video, apps, and dashboards, returned to your agent as finished work.
        </p>
        <button
          type="button"
          data-msc-suppress
          className="aie-btn aie-btn-primary aie-close__cta"
          onClick={() => onPrimary('close')}
        >
          {ctaLabel}
          <ArrowRightOutlined />
        </button>
        <p className="a2a-close__note">
          Try it free, no credit card needed. Every account starts with 200 credits.
        </p>
      </div>
    </section>
  );
};

export default A2AClose;
